import { Injectable } from '@angular/core';
import { SECTIONS_BY_STATUS } from '../constants/upplm.constants.dashboard';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ServiceURLConstants, ApiErrorCode } from '../constants/upplm.constants';
import { UpsCommonService } from './upplm.common.service';
import { DashboardRequest } from '../api/models/dashboardRequest';

const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json'})
};


@Injectable()

export class UpsDashboardService {
    constructor(private httpclient: HttpClient,
        private _commonService: UpsCommonService,) { }

    getDashboardSectionsByStatus(status: string): string[] {
        let sections: string[] = [];
        sections = SECTIONS_BY_STATUS.filter(section => section.status === status);
        return sections['0'].sections;
    };

    getPlacardDetail(request: DashboardRequest) {
        const url = this._commonService.createURL(ServiceURLConstants.GET_DASHBOARD_INFORMATION, ApiErrorCode.GET_DASHBOARD_INFORMATION);
        return this.httpclient.post<any>(url, JSON.stringify(request), httpOptions);
    }

}
